import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {routePaths} from "./core/config";

@Component({
  selector: 'not-found',
  template: `<div class="expire-message">
Your session has been expired. <a (click)="click()">Click here to login again</a> </div>`,
})
export class SessionExpireComponent {
  constructor(private router: Router) {
  }

  click() {
    this.router.navigate([`/${routePaths.login}`])
  }
}
